import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import router from '@/router';

const stack = [];
let ignoreNextPopstate = false;

window.addEventListener('popstate', () => {
    if (ignoreNextPopstate) {
        ignoreNextPopstate = false;
        return;
    }
    const close = stack[stack.length - 1];
    if (close) close();
});

export function openDialog(DialogComponent, props = {}) {
    return new Promise(resolve => {
        const DialogClass = Vue.extend(DialogComponent);
        const instance = new DialogClass({
            vuetify,
            store,
            router,
            propsData: props,
        });

        const cleanup = result => {
            resolve(result);
            instance.$nextTick(() => {
                instance.$destroy();
                instance.$el?.parentNode?.removeChild(instance.$el);
            });
        };

        // Push a closer for this dialog onto the stack so back button
        // only closes the topmost open dialog
        stack.push(() => cleanup(null));
        history.pushState(null, '');

        instance.$on('close', result => {
            stack.pop();
            // Suppress the popstate that history.back() is about to fire
            // so it doesn't accidentally close the parent dialog
            ignoreNextPopstate = true;
            history.back();
            cleanup(result);
        });

        instance.$mount();
        document.body.appendChild(instance.$el);
    });
}
